/**
 * @generated SignedSource<<f6ad31bc4be2c237aaaa6490de97e71b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useItemMediaItems_muxVideo$data = {
  readonly __typename: "VideoV2";
  readonly " $fragmentType": "useItemMediaItems_muxVideo";
};
export type useItemMediaItems_muxVideo$key = {
  readonly " $data"?: useItemMediaItems_muxVideo$data;
  readonly " $fragmentSpreads": FragmentRefs<"useItemMediaItems_muxVideo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useItemMediaItems_muxVideo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "type": "VideoV2",
  "abstractKey": null
};

(node as any).hash = "b6bf004a67a2dbc406f9c13269c3551d";

export default node;
